import React from 'react'

import * as yup from 'yup'
import { Formik } from 'formik'
import FormSection from '../../../components/FormSection/FormSection'
import FormInputsEn from './FormInputsEn'
import FormInputsSr from './FormInputsSr'
// import FormInputs from './FormInputs'
import FormWrapper from '../../../components/FormWrapper/FormWrapper'

const AboutForm = ({ initialValues, onSubmit, onDelete, language, isEditForm = false }) => {
    const payloadSchema = yup.object().shape({
        aboutShort: yup.string().required(),
        aboutShortEn: yup.string().required(),
    })

    const _aboutForm = (props) => {
        return (
            <FormSection
                {...props}
                FormInputsEn={FormInputsEn}
                FormInputsSr={FormInputsSr}
                // FormInputs={FormInputs}
                isEditForm={isEditForm}
                onDelete={onDelete}
            />
        )
    }

    return (
        <FormWrapper>
            <Formik
                initialValues={initialValues}
                enableReinitialize
                validationSchema={payloadSchema}
                onSubmit={onSubmit}
            >
                {_aboutForm}
            </Formik>
        </FormWrapper>
    )
}

export default AboutForm
